import script from "./Button.vue?vue&type=script&setup=true&lang=js"
export * from "./Button.vue?vue&type=script&setup=true&lang=js"

import "./Button.vue?vue&type=style&index=0&id=410ed48a&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-410ed48a"]])

export default __exports__